import React from 'react'
import styled from 'styled-components'
import { Checkbox, FormControl, FormControlLabel } from '@mui/material'

import { Answer, Question } from '../../../types'
import theme from '../../../theme'

interface Props {
  question: Question
  onSelect: (answer: Answer, isConditionalRoute: boolean, isChecked: boolean) => void
  selectedValues: string[]
  title: string
}

const Multiple: React.FC<Props> = ({ question, onSelect, selectedValues, title }) => {
  const { answers } = question
  const legendTitle = title

  const styles = {
    textAlign: 'left',
    alignItems: 'center',
    backgroundColor: 'white',
    border: 'solid',
    borderColor: theme.lightGrey,
    borderRadius: 0.5,
    borderWidth: 1,
    boxShadow: 'none',
    color: theme.blue,
    flexDirection: 'row',
    fontFamily: theme.primaryFont,
    height: '100%',
    lineHeight: '1.28',
    margin: 0,
    padding: '25px',
    textDecoration: 'none',
    textTransform: 'none',
    transition: 'all 0.3s ease',
    width: '100%',
    '&:hover': {
      boxShadow: '0 2px 10px 0 rgba(30, 30, 30, 0.4)',
      backgroundColor: theme.blue,
      borderColor: theme.blue,
      color: 'white',
      '& svg': {
        fill: 'white',
      },
    },
    '&:focus-within': {
      outline: '5px auto #005fcc',
      outlineOffset: '5px',
    },
    '&>span': {
      fontSize: '25px',
      fontFamily: theme.primaryFont,
    },
  }

  return (
    <FormControl
      component="fieldset"
      sx={{
        marginTop: '60px',
        width: '100%',
        maxWidth: '604px',
      }}
    >
      <legend className="sr-only">{legendTitle}</legend>
      {answers &&
        answers.map((answer: Answer, index) => (
          <ButtonContainer checked={selectedValues.includes(answer.title)} key={index}>
            <FormControlLabel
              value="test"
              control={
                <Checkbox
                  color="primary"
                  onClick={() => {
                    const isConditionalRoute = !!answer.conditionalRoute || !!answer.nextRouteId
                    onSelect(answer, isConditionalRoute, selectedValues.includes(answer.title))
                  }}
                  checked={selectedValues.includes(answer.title)}
                />
              }
              label={answer.title}
              sx={[styles]}
            />
          </ButtonContainer>
        ))}
    </FormControl>
  )
}

const ButtonContainer = styled.div<{ checked: boolean }>`
  width: 100%;
  margin: 5px 0;

  ${({ checked, theme }) =>
    checked &&
    `
    > .MuiFormControlLabel-root {
      background-color: ${theme.blue};
      color: white;
      box-shadow: 0 2px 10px 0 rgba(30, 30, 30, 0.4);
      border-color: ${theme.blue};

      & svg {
        fill: white
      }
    }
  `};
`

export default Multiple
